module.exports = __webpack_public_path__ + "img/67.9210b3d6.png";